import { render, staticRenderFns } from "./DyFavorite.vue?vue&type=template&id=2bc5dbe2&scoped=true"
import script from "./DyFavorite.vue?vue&type=script&lang=js"
export * from "./DyFavorite.vue?vue&type=script&lang=js"
import style0 from "./DyFavorite.vue?vue&type=style&index=0&id=2bc5dbe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc5dbe2",
  null
  
)

export default component.exports